import * as React from 'react';
import 'chart.piecelabel.js';

import { LinearProgress, Typography, Paper } from '@material-ui/core';
import { ChartLegendOptions } from 'chart.js';
import { Percentual, NumberConvert, NumberPercent } from 'src/services';
import { Doughnut } from 'react-chartjs-2';
import { ResponsiveContainer } from 'recharts';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareMarketProps {
    dataBilling : any;
    dataBillingMk : any;
    loading : boolean;
}

export interface IMarketShareBookstoreShareMarketState {
    customFilter: {
        isChart: boolean
    },
}

const COLORS = ['#FF6A14','#323232','#20B2AA', '#F5DEB3', '#FFBB28', '#FF8042','#90EE90',
'#FFB6C1','#FFA07A','#0088FE','#87CEFA','#778899','#B0C4DE',
'#008080','#D8BFD8','#FF6347','#40E0D0','#EE82EE','#00C49F'];

const legenda: ChartLegendOptions = {};
legenda.position = "left";

const getLabel = (tooltipItems: any, data: any) => {
    return ['Livraria: ' + data.labels[tooltipItems.index],
     'Share:    ' +  Percentual(data.datasets[0].data[tooltipItems.index].toString())];
}

const opts: any = {};
opts.tooltips = { displayColors: false , callbacks: {label: getLabel}};
opts.pieceLabel = {
    fontColor: '#555555',
    position: 'outside',
    render: (args: any) =>  {
        return Percentual(args.value.toString());
    }
}

export interface IMarketShareBookstoreShareMarketDataChart {
    name: string;
    value: number;
}

const MarketShareBookstoreShareMarketChart = ({ data }: { data: Chart.ChartData }) => (
    <ResponsiveContainer width="100%" height={370}>
        <Doughnut key="value" data={data} legend={legenda} options={opts} />
    </ResponsiveContainer>
);

const dataFilled = (data: any) => {
    return data && !!data.length
}

export class MarketShareBookstoreShareMarket extends React.Component<IMarketShareBookstoreShareMarketProps, IMarketShareBookstoreShareMarketState> {
    constructor(props: IMarketShareBookstoreShareMarketProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }

    public render() {
        const data : any[] = [];
        if(this.props.dataBilling && this.props.dataBillingMk 
            && this.props.dataBilling.marketShareBookstoreShareBilling != null 
            && this.props.dataBilling.marketShareBookstoreShareBilling !== undefined
            && this.props.dataBillingMk.marketShareBookstoreShareBillingMarket != null 
            && this.props.dataBillingMk.marketShareBookstoreShareBillingMarket !== undefined) {


            const percetBookstore = NumberPercent(
                NumberConvert(this.props.dataBillingMk.marketShareBookstoreShareBillingMarket.current_year),
                NumberConvert(this.props.dataBilling.marketShareBookstoreShareBilling.current_year)
            );

            if(percetBookstore) {
                data[0] = {
                    name: 'Sua Livraria',
                    value: percetBookstore
                };
    
                data[1] = {
                    name: 'Mercado',
                    value: (100-percetBookstore)
                }
            }
        }

        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    Share Livrarias X Mercado - 30 Dias
                </Typography>
                {
                    this.props.loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (<MarketShareBookstoreShareMarketChart data={this.MarketShareBookstoreShareMarketMap(data)} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }
    
    private MarketShareBookstoreShareMarketMap = (data: IMarketShareBookstoreShareMarketDataChart[]) => {

        const mappedData: Chart.ChartData = {};
        const labels: string[] = [];
        const values: any[] = [];
        const datasetss: any = {};

        data.forEach(e => {
            const item: IMarketShareBookstoreShareMarketDataChart = {
                name: e.name,
                value: e.value,
            };

            labels.push(item.name);
            values.push(item.value);
        });

        datasetss.data = values;
        datasetss.backgroundColor = COLORS;
        mappedData.datasets = [datasetss];
        mappedData.labels = labels;

        return mappedData;
    }
}


// WEBPACK FOOTER //
// ./src/component/market/bookstore/marketShare/market/MarketShareBookstoreShareMarket.tsx